<app-header/>

<app-delivery-targeted *ngIf="delivery === 1 || delivery > 30" (selectedDeliveryType)="setDelivery($event)"/>

<app-pickup-amosova *ngIf="delivery == 2" (selectedDeliveryType)="setDelivery($event)"/>

<app-nova-poshta *ngIf="delivery == 3 || delivery == 11" (selectedDeliveryType)="setDelivery($event)"/>

<app-meest-express *ngIf="delivery == 15" (selectedDeliveryType)="setDelivery($event)"/>

<app-delivery *ngIf="delivery == 5" (selectedDeliveryType)="setDelivery($event)"/>

<app-pickup-brojka *ngIf="delivery == 7" (selectedDeliveryType)="setDelivery($event)"/>

<app-dropship *ngIf="delivery == 8" (selectedDeliveryType)="setDelivery($event)"/>
